import React from 'react';
import { motion } from 'framer-motion';
export function Divider() {
  return <div className="flex items-center justify-center py-12" data-id="element-219">
      <motion.div initial={{
      scaleX: 0,
      opacity: 0
    }} whileInView={{
      scaleX: 1,
      opacity: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 1,
      ease: 'easeInOut'
    }} className="w-24 h-px bg-gold" data-id="element-220" />
      <motion.div initial={{
      scale: 0,
      opacity: 0
    }} whileInView={{
      scale: 1,
      opacity: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5,
      delay: 0.5
    }} className="w-2 h-2 rounded-full bg-gold mx-4" data-id="element-221" />
      <motion.div initial={{
      scaleX: 0,
      opacity: 0
    }} whileInView={{
      scaleX: 1,
      opacity: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 1,
      ease: 'easeInOut'
    }} className="w-24 h-px bg-gold" data-id="element-222" />
    </div>;
}